<template>
  <div id="module">
    <el-container>
      <!-- 左侧导航 -->
      <Nav />
      
      <el-container class="maincontent">
        <!-- 头部 -->
        <el-header style="height: 54px;background: #fff;">
          <div class="header-menu">
            <ul class="menu-list">
              <!-- <li class="menu-list-li" v-if="institutionalaccreditation">
                <div class="headerinstitutional" @click="$router.push('/digitalize/institutionalaccreditation')"><span>构</span>机构认证</div>
              </li> -->
              <li class="menu-list-li">
                <div slot="reference" class="el-icon-chat-dot-round" style="float: left;line-height: 54px;margin-left: 5px;color: #d1d1d2;"></div>
                <span class="username">{{ $t('original.messages') }}</span>
                <span class="msg-tip" v-if="Counts3 > 0">{{ Counts3 }}</span>
                
                <div class="messagess" v-if="wdata.length > 0">
                  <ul style="text-align: right; margin: 0;" class="headermenu">

                    <li class="headermenu__item" v-for="(item, index) in wdata" :key="index" :class="item.MsgState == 0 ? 'No-Read' : 'Do-Read'" @click="handleEdit(index, item)">
                      <div class="tip"></div>
                      <div class="cnt">{{ item.Message }}</div>
                    </li>

                  </ul>
                </div>
              </li>
              
              <li>
                <el-avatar :src="Global.headPhoto" class="userinformation-box">
                  <img src="../assets/img/manHead.png"/>
                </el-avatar>
                <div class="username">{{ UserInfo.UserName }}</div>
                <el-popover placement="bottom-end" width="80" trigger="hover">
                  <ul style="text-align: right; margin: 0px;" id="menu" class="headermenu">
                    <a>
                      <li class="headermenu__item" @click="goBack()">
                        {{ $t('original.languages241') }}
                      </li>
                      <li class="headermenu__item" @click="indexdialogVisible = true">
                        {{ $t('original.languages242') }}
                      </li>
                      <li class="headermenu__item" @click="AboutUsdialog = true">
                        关于我们
                      </li>
                    </a>
                  </ul>
                  <div slot="reference" class="el-icon-arrow-down more-menu" style="float: right;line-height: 54px;margin-left: 5px; color: #d1d1d2;"></div>
                </el-popover>
              </li>
            </ul>
          </div>
          <Top />
        </el-header>
        <el-row style="margin-bottom: 0px;height: 40px;width: 100%;background-color: crimson;position: relative !important;z-index: 999 !important;background-color: #fff !important;">
          <el-col :span="24">
            <div class="grid-content bg-purple-dark">
              <Breadcrumb />
            </div>
          </el-col>
        </el-row>
        <!-- 主体部分 -->
        <el-main style="background-color: rgba(235, 236, 237, 1); width: 100%;">

          <!-- <keep-alive > -->
            <!-- <router-view /> -->
          <!-- </keep-alive> -->

          <keep-alive>
              <router-view v-if="$route.meta.keepAlive">
                  <!--这里是会被缓存的路由-->
              </router-view>
          </keep-alive>

          <router-view v-if="!$route.meta.keepAlive">
              <!--因为用的是v-if 所以下面还要创建一个未缓存的路由视图出口-->
          </router-view>

          
        </el-main>
        <Footer />
      </el-container>
    </el-container>

    <el-dialog class="cshoiaxa" :title="$t('original.languages242')" :visible.sync="indexdialogVisible" width="66%" :before-close="handleClose">
      <el-tabs v-model="indexactiveName">

        <el-tab-pane label="用户管理" name="first">
  <!-- v-if="RoleID == '1059'" -->
          <el-form v-if="this.Global.pdroleid(1059)" :model="zusruleForm" ref="zusruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="姓名">
              <el-input v-model="zusruleForm.RealName"></el-input>
            </el-form-item>
            <el-form-item label="账号">
              <el-input v-model="zusruleForm.UserID"></el-input>
            </el-form-item>
            <el-form-item label="手机号">
              <el-input v-model="zusruleForm.Phone"></el-input>
            </el-form-item>
            <el-form-item label="邮箱">
              <el-input v-model="zusruleForm.Email"></el-input>
            </el-form-item>

            <el-form-item label="身份证号">
              <el-input v-model="zusruleForm.IDCard"></el-input>
            </el-form-item>

            <el-form-item label="校区" prop="campus">
              <el-select v-model="zusruleForm.Bak2" placeholder="请选择">
                <el-option v-for="item in campus_list" :key="item.cDicEnglishValue" :label="item.cDicValue"
                  :value="item.dicKey">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="擅长方向">
              <el-input type="textarea" v-model="zusruleForm.Expertise"></el-input>
            </el-form-item>

            <el-form-item label="个人介绍">
              <el-input type="textarea" v-model="zusruleForm.IndividualResume"></el-input>
            </el-form-item>

            <el-form-item label="咨询师级别">
              <span>{{ zusruleForm.positionName==null?'暂未设置':zusruleForm.positionName }}</span>
            </el-form-item>

            

            <el-form-item label="籍贯">
              <el-select v-model="zusruleForm.NativePlace" :placeholder="$t('original.languages3')">
                <el-option v-for="item in indexval" :key="item.dicKey" :label="item.cDicValue" :value="item.dicKey">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="民族">
              <el-select v-model="zusruleForm.Nation" placeholder="请选择民族">
                <el-option v-for="item in indexval2" :key="item.dicKey" :label="item.cDicValue" :value="item.dicKey">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item :label="$t('original.gender')">
              <el-radio v-model="zusruleForm.Sex" label="1">男</el-radio>
              <el-radio v-model="zusruleForm.Sex" label="0">女</el-radio>
            </el-form-item>

            <el-form-item label="出生日期" prop="Birthday">
              <el-date-picker value-format="yyyy-MM-dd" v-model="zusruleForm.Birthday" type="date" :placeholder="$t('original.languages3')"></el-date-picker>
            </el-form-item>

            <el-form-item label="头像" >
              <div>
                <el-upload :on-change="(file => {return handleChange(file, 1);})" :auto-upload="false" class="avatar-uploader" action="" :show-file-list="false" accept="image/jpeg,image/gif,image/png" >
                  <img v-if="zusruleForm.ZHeadPhotoURL" :src="zusruleForm.ZHeadPhotoURL" class="avatar" />
                  <i v-else class="el-icon-plus avatar-uploader-icon">
                    <span style="font-size: 16px;">点击选择文件</span>
                  </i>
                </el-upload>
              </div>
              <!-- <div style="width: 140px;height: 140px;background-color: aqua;margin-left: 230px;">
              </div> -->
            </el-form-item>

            <el-form-item label="无犯罪证明" style="margin-top: 150px;">
              <el-upload :on-change="(file => {return handleChange(file, 2)})" :auto-upload="false" class="avatar-uploader" action="" :show-file-list="false" accept="image/jpeg,image/gif,image/png">
                <img v-if="zusruleForm.CriminalCheck" :src="zusruleForm.CriminalCheck" class="avatar" />
                <i v-else class="el-icon-plus avatar-uploader-icon">
                  <span style="font-size: 16px;">点击选择文件</span>
                </i>
              </el-upload>
            </el-form-item>

            <el-form-item label="专业技能证书上传(最多可上传5张证书)" style="margin-top: 150px;">
              <el-upload :on-change="(file => {return handleChange(file, 3);})" :auto-upload="false" class="avatar-uploader" action="" :show-file-list="false" accept="image/jpeg,image/gif,image/png">
                <img v-if="imageUrl" :src="imageUrl" class="avatar" />
                <i v-else class="el-icon-plus avatar-uploader-icon">
                  <span style="font-size: 16px;">点击选择文件</span>
                </i>
              </el-upload>

              <ul style="margin-left: 240px;">
                <li style="width: 180px;height: 180px;margin-left: 10px;float: left;position: relative;overflow: auto;" v-for="(item,i) in guolist1" :key="i">
                  <span style="width: 100%;color: #fff;text-align: center;height: 30px;line-height: 30px;background-color: rgba(000,000,000,0.5);position: absolute;top: 0px;left: 0px;cursor:pointer" @click="delfun(i, item)">删除111</span>
                  <img style="width: 100%;" :src="item" alt="">
                </li>
              </ul>
            </el-form-item>

            <el-form-item label="专业技能认证说明" style="margin-top: 60px;">
              <el-input type="textarea" v-model="zusruleForm.CertificateInstruction"></el-input>
            </el-form-item>

            <el-form-item label="聘用时间">
                <!-- <el-date-picker value-format="yyyy-MM-dd" v-model="zusruleForm.Appointmenttime" type="date" :placeholder="$t('original.languages3')"></el-date-picker> -->

                <el-date-picker :disabled="true" value-format="yyyy-MM-dd" format="yyyy-MM-dd" v-model="zusruleForm.AppointmentStart" type="date" :placeholder="$t('original.languages3')"></el-date-picker>
                至
                <el-date-picker :disabled="true" value-format="yyyy-MM-dd" format="yyyy-MM-dd" v-model="zusruleForm.AppointmentEnd" type="date" :placeholder="$t('original.languages3')"></el-date-picker>

              </el-form-item>

              <el-form-item label="聘用说明">
                <el-input type="textarea" :disabled="true" v-model="zusruleForm.AppointmentInstruction"></el-input>
              </el-form-item>
            
            <el-form-item label="附件文件" style="margin-top: 30px;height: 180px;">
              <el-upload :on-change="(file => {return handleChange(file, 4)})" :auto-upload="false" class="avatar-uploader" action="image/jpeg,image/gif,image/png,application/pdf" :show-file-list="false" accept="">
                <img v-if="imageUrl" :src="imageUrl" class="avatar" />
                <i v-else class="el-icon-plus avatar-uploader-icon">
                  <span style="font-size: 16px;">点击选择文件</span>
                </i>
              </el-upload>

              <ul style="margin-left: 240px;">
                <li style="width: 180px;height: 30px;margin-left: 10px;position: relative;background-color: #64d15d;margin-top: 10px;line-height: 30px;color: #fff;border-radius: 5px;width: 550px;position: relative;" v-for="(item,i) in guolist2" :key="i">
                  <span style="margin-left: 20px;width: 450px;overflow: auto;display: inline-block;">{{ item.name }}</span>
                  <span style="position: absolute;right: 10px;top: 0px; cursor:pointer;z-index: 99;background-color: #64d15d" @click="delfun2(i,item)">删除</span>
                </li>
              </ul>

            </el-form-item>

          </el-form>

          <el-button @click="zus_save()" v-if="this.Global.pdroleid(1059)" style="margin-left: 49%; margin-bottom: 20px;" type="primary">
            保存
          </el-button>

          <el-form v-if="!this.Global.pdroleid(1059)"  :model="indexruleForm2" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item :label="$t('original.languages79')" prop="lpass">
              <el-input :disabled="true" v-model="indexruleForm2.UserID"></el-input>
            </el-form-item>

            <el-form-item :label="$t('original.name')" prop="newpass">
              <el-input v-model="indexruleForm2.RealName"></el-input>
            </el-form-item>

            <el-form-item label="视频号" prop="newpass">
              <el-input v-model="indexruleForm2.VideoAccount"></el-input>
            </el-form-item>

            <el-form-item :label="$t('original.Name_of_Company')" prop="DeptID">
              <el-input :disabled="true" v-model="indexruleForm2.DeptID"></el-input>
            </el-form-item>
            
            <el-form-item :label="$t('original.Id_number')" prop="IDCard">
              <el-input v-model="indexruleForm2.IDCard"></el-input>
            </el-form-item>

            <el-form-item label="婚姻状态">
              <el-select v-model="indexruleForm2.MarriageState" :placeholder="$t('original.languages3')">
                <el-option v-for="item in value7" :key="item.dicKey" :label="item.cDicValue" :value="item.dicKey">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="籍贯" prop="NativePlace">
              <el-select v-model="indexruleForm2.NativePlace" :placeholder="$t('original.languages3')">
                <el-option v-for="item in indexval" :key="item.dicKey" :label="item.cDicValue" :value="item.dicKey">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="民族" prop="Nation">
              <el-select v-model="indexruleForm2.Nation" placeholder="请选择民族">
                <el-option v-for="item in indexval2" :key="item.dicKey" :label="item.cDicValue" :value="item.dicKey">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item :label="$t('original.gender')" prop="Sex">
              <el-radio v-model="indexruleForm2.Sex" label="1">男</el-radio>
              <el-radio v-model="indexruleForm2.Sex" label="0">女</el-radio>
            </el-form-item>

            <el-form-item label="出生日期" prop="Birthday">
              <el-date-picker value-format="yyyy-MM-dd" v-model="indexruleForm2.Birthday" type="date" :placeholder="$t('original.languages3')"></el-date-picker>
            </el-form-item>

            <el-form-item label="入学时间" prop="TheEntranceDate">
              <el-date-picker value-format="yyyy-MM-dd" v-model="indexruleForm2.TheEntranceDate" type="date" :placeholder="$t('original.languages3')"></el-date-picker>
            </el-form-item>

            <el-form-item :label="$t('original.phone')" prop="Phone">
              <el-input v-model="indexruleForm2.Phone"></el-input>
            </el-form-item>

            <el-form-item :label="$t('original.mailbox')" prop="Email">
              <el-input v-model="indexruleForm2.Email"></el-input>
            </el-form-item>

            <el-form-item label="紧急联系人" prop="Email">
              <el-input v-model="indexruleForm2.EmergencyName" placeholder="紧急联系人"></el-input>
            </el-form-item>

            <el-form-item label="联系人关系" prop="Email">
              <el-select v-model="indexruleForm2.UrgentRelationships" placeholder="请选择联系人关系">
                <el-option v-for="item in value77" :key="item.dicKey" :label="item.cDicValue" :value="item.dicKey">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="联系人电话" prop="Email">
              <el-input v-model="indexruleForm2.EmergencyPhone" placeholder="紧急联系人电话"></el-input>
            </el-form-item>

            <!-- <el-form-item :label="$t('original.Id_number')" prop="IDCard">
              <el-input v-model="indexruleForm2.IDCard"></el-input>
            </el-form-item> -->
            <el-form-item :label="$t('original.Account_type')" prop="AccountType">
              <el-radio v-model="indexruleForm2.AccountType" label="1">
               {{ $t('original.languages7') }}
              </el-radio>
              <el-radio v-model="indexruleForm2.AccountType" label="2">
                {{ $t('original.languages8') }}
              </el-radio>
            </el-form-item>
          </el-form>
          
          <el-button v-if="!this.Global.pdroleid(1059)" @click="save" :disabled="csbjb" style="margin-left: 49%; margin-bottom: 20px;" type="primary">
            {{ $t('original.save') }}
          </el-button>

        </el-tab-pane>

        <el-tab-pane :label="$t('original.languages244')" name="second">

          <el-form :model="ruleForm" ref="ruleForm" label-width="100px" class="demo-ruleForm" :rules="rules"
            style="width: 50%; margin: auto;">

            <el-form-item :label="$t('original.languages245')" prop="lpass">
              <el-input type="password" v-model="ruleForm.lpass" :placeholder="$t('original.languages4')" maxlength="20"></el-input>
            </el-form-item>

            <el-form-item :label="$t('original.languages246')" prop="newpass">
              <el-input type="password" v-model="ruleForm.newpass" :placeholder="$t('original.languages4')" maxlength="20"></el-input>
            </el-form-item>

            <el-form-item :label="$t('original.languages247')" prop="newpass2">
              <el-input type="password" v-model="ruleForm.newpass2" :placeholder="$t('original.languages4')" maxlength="20"></el-input>
            </el-form-item>

          </el-form>

          <el-button @click="tj('ruleForm')" style="margin-left: 49%;" type="primary">
             {{ $t('original.save') }}
          </el-button>

        </el-tab-pane>

        <el-tab-pane label="个人画像" name="portrait">
          <iframe :src="VUE_APP_URLs+'/File/Regist/Userprofile.html?userID='+userxs+'&token='+Authorization" style="width: 375px;height: 65vh;margin: auto;display: block;"></iframe>
        </el-tab-pane>

      </el-tabs>
    </el-dialog>

    <el-dialog title="消息内容" :visible.sync="titsdialogVisible" width="30%" :before-close="handleClose">
      <p style="padding: 30px;">{{ tits }}</p>
      <el-button style="margin-left: 45%;" type="primary" @click="titsdialogVisible = false">确 定</el-button>
    </el-dialog>

    <!-- 关于我们 -->
    <el-dialog title="关于我们" :visible.sync="AboutUsdialog" width="50%">
        <div class="about">
          <el-form>
            <el-form-item>
              <el-col :span="8">版本号: {{ $t("original.foottitle").split("号")[1]}}</el-col>
              <el-col :span="12">更新时间:2023-10-10</el-col>
            </el-form-item>
            <el-form-item>
              <!-- <el-col :span="12">版本权归属: 中国国家科大学院大学</el-col> -->
              <el-col :span="12">技术支持:上海北辰软件股份有限公司</el-col>
            </el-form-item>
            <el-form-item>
              本次更新：<br/>

            </el-form-item>
          </el-form>
        </div>
    </el-dialog>

  </div>
</template>
<script>

import Nav from './Nav'
import Top from './Top'
import Breadcrumb from './Breadcrumb'
import Footer from './Footer'
export default {
  data() {
    return {
      Authorization:sessionStorage.getItem('Authorization'),
      VUE_APP_URLs:process.env.VUE_APP_URLs,
      institutionalaccreditation:JSON.parse(sessionStorage.getItem('xinxi')).OrgCode,
      AboutUsdialog:false,
      tits: "",
      titsdialogVisible:false,
      guolist1:[],
      guolist2: [],
      imageUrl: '',
      axaxax: '',
      file: '',
      campus_list:[],
      zusruleForm: {
        ZHeadPhotoURL: "",//头像
        UserID: "", //账号
        RealName: "",//姓名
        Sex: "",//性别
        Birthday: null,//出生日期
        IDCard: "",//身份证号
        Phone: "", //手机号
        Email: "",//邮箱
        NativePlace: "",//籍贯
        Position: "",
        positionName: null,//咨询师级别
        Nation: "",//民族
        IndividualResume: "",//个人介绍
        Bak2: "",//校区
        Expertise: "", //擅长方向
        CertificateInstruction: "",//技能认证说明
        CriminalCheck: "",//无犯罪证明
        ConsultantAttachment: [],//续聘附件材料
        AppointmentStart: "", //聘用开始日期
        AppointmentEnd: "", //聘用借宿日期
        AppointmentInstruction: "", //聘用说明
        ConsultantCertificate: [],//专业技能证书
      },
      value7:[],
      value77:[],
      RoleID:'',
      indexval2: '',
      indexval: '',
      csbjb: false,
      ruleForm: {
        lpass: '',
        newpass: '',
        newpass2: '',
      },
      indexruleForm2: {
        UserID: '',
        RealName: '',
        Sex: '',
        Birthday: '',
        Phone: '',
        IDCard: '',
        AccountType: '',
        DeptID: '',
        Nation: '',
        NativePlace: '',
        TheEntranceDate: '',
        Email: '',
        MarriageState: '',
        VideoAccount:'',
        EmergencyName:'',
        UrgentRelationships:'',
        EmergencyPhone:'',
      },
      indexactiveName: 'second',
      indexdialogVisible: false,
      UserInfo: localStorage.getItem('userInfo')? JSON.parse(localStorage.getItem('userInfo')): {},
      show: true,
      userxs: this.Global.userID,
      xaxbjv: this.Global.roletype,
      fromdata: {pageSize: '10',pageIndex: '1',},
      wdata: [],
      loadings: false,
      Counts3: 0,
      currentPag2: 1,
      centerDialogVisible: false,
      xs: '',
      rules: {
        lpass: [{required: true,message: '请输入原始密码!',trigger: 'blur'},],
        newpass: [
          {
            required: true,
            pattern: /(?!\d+$)(?!^[a-zA-Z]+$)(?!^[_#@]+$).{8,20}/,
            message: '8至20位，包含数字、英文字母',
            trigger: 'blur',
          },
        ],
        newpass2: [
          {
            required: true,
            pattern: /(?!\d+$)(?!^[a-zA-Z]+$)(?!^[_#@]+$).{8,20}/,
            message: '8至20位，包含数字、英文字母',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  components: {
    Nav,
    Top,
    Breadcrumb,
    Footer,
  },
  methods: {
    delfun(i,item) {
      this.guolist1.splice(i, 1);
    },
    delfun2(i, item) {
      this.guolist2.splice(i, 1);
    },
    pad(val) {

    },
    handleChange(file, val) {
        var from = new FormData();
        if (file.size > 10485760) {
          alert("图片大小不能超过10M")
        } else {
          from.append('images', file.raw);
          this.$Http_Post('/AppUser/UpdatePortraitAndCertificate', from).then((res) => {
            if (res.Code == 200 || res.Code == 0) {
              // this.imageUrl = res.Data
              if (val == '1') {//头像
                this.zusruleForm.ZHeadPhotoURL = res.Data
              } else if (val == '2') {//无犯罪证明
                this.zusruleForm.CriminalCheck = res.Data
              } else if (val == '3') {//专业技能证书上
                if (this.zusruleForm.ConsultantCertificate.length <= 4) {
                  this.guolist1.push(res.Data);
                } else {
                  alert("最多上传五张证书")
                }
              } else if (val == '4') {//附件文件
                this.guolist2.push({
                  name: file.raw.name,
                  img: res.Data
                });
                // this.zusruleForm.ConsultantAttachment.push(res.Data);
              }
            }
          })
        }
    },

    // beforeAvatarUpload(file) {
    //   debugger
    //   const isLt2M = file.size / 1024 / 1024 < 8
    //   if (!isLt2M) {
    //     this.$message.error('上传头像图片大小不能超过 2MB!')
    //   }
    //   return isLt2M
    // },


    save() {
      this.csbjb = true
      this.$Http_Post('User/UpdatePersonalData', this.indexruleForm2).then(
        (res) => {
          if (res.Code == 200 || res.Code == 0) {
            location.reload();
            this.csbjb = false;
            this.Global.request_successful(res.Message);
          } else {
            this.csbjb = false;
            this.Global.request_failure(res.Message);
          }
          this.loading(1, '');
        },
      )
    },

    tj(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$Http_Post('User/GetChangePassword', {
            FistPwd: this.ruleForm.newpass,
            LastPwd: this.ruleForm.newpass2,
            Pwd: this.ruleForm.lpass,
          }).then((res) => {
            if (res.Code == 200 || res.Code == 0) {
              this.Global.request_successful(res.Message);
              sessionStorage.removeItem('username');
              this.$router.push('/login');
            } else {
              this.Global.request_failure(res.Message);
            }
          })
        } else {
          this.Global.request_failure('信息填写有误!')
          return false;
        }
      })
    },
    handleClick(tab, event) {
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then((_) => {
          done()
        })
        .catch((_) => { })
    },
    handleEdit(a, b) {
      this.tits = b.Message;
  
      this.titsdialogVisible = true;
      this.centerDialogVisible = true;
      if (this.wdata[a].MsgState == 0) {
        this.xs = b;
        var frata = { MessageID: b.messageID, UserID: b.UserID }
        let _this = this;
        this.$Http_Post('ConsultSubscribe/UpdateNotification', {from: frata}).then((res) => {
          this.loadings = false
          if (res.Code == 200 || res.Code == 0) {
            _this.wdata[a].MsgState = 1;
            _this.Counts3 = _this.Counts3 - 1;
          } else {
            this.Global.request_failure(res.Message)
          }
        })
      }
    },
    goBack() {
      this.$Http_Get('/login/cas/logout').then(res=>{
        if(res.Code==0){
          if(res.Data){
            localStorage.clear();
            sessionStorage.clear();  
            location.href=res.Data;
          }else{
            sessionStorage.removeItem('username');
            this.$i18n.locale = "ch";
            this.$router.push('/login');
          }
        }else{
          this.Global.request_failure(res.Message)
        }
      });
      // sessionStorage.removeItem('username');
      // this.$i18n.locale = "ch";
      // this.$router.push('/login');
    },
    handleSizeChange2(obj, e) { },
    handleCurrentChange2(obj, e) {
      this.fromdata.pageIndex = obj;
      this.Laborstatistics();
    },
    Laborstatistics() {
      this.$Http_Post('ConsultSubscribe/ShoNotification', {from: this.fromdata,}).then((res) => {
        this.loadings = false
        if (res.Code == 200 || res.Code == 0) {
          this.wdata = res.Data;
          this.Counts3 = Number(res.Counts);
        } else {
          this.Global.request_failure(res.Message);
        }
      })
      .catch((err) => {
        this.$message({
          type: 'error',
          message: err.message,
        })
      })
    },
    zus_save() {//保存
      for (let i = 0; i < this.campus_list.length; i++) {
        if (this.campus_list[i].dicKey == this.zusruleForm.Bak2) {
          this.zusruleForm.Bak2 = this.campus_list[i].cDicValue
        }
      }
      this.zusruleForm.ConsultantCertificate = this.guolist1.toString();
      for (let i = 0; i < this.guolist2.length; i++){
        this.zusruleForm.ConsultantAttachment.push(this.guolist2[i].img)
      }
      this.zusruleForm.ConsultantAttachment = this.zusruleForm.ConsultantAttachment.toString();
      this.$Http_Post('User/UpdateUser',  this.zusruleForm ).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Global.request_successful(res.Message);
          this.indexdialogVisible = false;
        } else {
          this.Global.request_failure(res.Message);
        }
      })

    }
  },
  mounted() {
    this.$Http_Post('User/GetDictionaryList', { DicTypCode: 19 }).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.value77 = res.Data;
      }
    })


    this.$Http_Post('User/GetDictionaryList', { DicTypCode: 13 }).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.value7 = res.Data;
      }
    })

    this.RoleID = JSON.parse(sessionStorage.getItem('xinxi')).RoleID;
    this.$Http_Post('User/GetDictionaryList', { DicTypCode: "24" }).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.indexval = res.Data;
      }
    })

    this.$Http_Post('User/GetDictionaryList', { DicTypCode: "22" }).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.indexval2 = res.Data;
      }
    })

    this.Laborstatistics();
    if (this.Global.pdroleid(1059)) {
      this.$Http_Get('/User/getCheckAuditList', { userId: JSON.parse(sessionStorage.getItem("xinxi")).UserID }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.zusruleForm = {
            ZHeadPhotoURL: res.Data.rows[0].ZHeadPhotoURL,//头像
            UserID: res.Data.rows[0].UserID, //账号
            RealName: res.Data.rows[0].RealName,//姓名
            Sex: res.Data.rows[0].Sex,//性别
            Birthday: res.Data.rows[0].Birthday,//出生日期
            IDCard: res.Data.rows[0].IDCard,//身份证号
            Phone: res.Data.rows[0].Phone, //手机号
            Email: res.Data.rows[0].Email,//邮箱
            NativePlace: res.Data.rows[0].NativePlace,//籍贯
            Position: res.Data.rows[0].Position,
            positionName: res.Data.rows[0].positionName,//咨询师级别
            Nation: res.Data.rows[0].Nation,//民族
            IndividualResume: res.Data.rows[0].IndividualResume,//个人介绍
            Expertise: res.Data.rows[0].Expertise, //擅长方向
            CertificateInstruction: res.Data.rows[0].CertificateInstruction,//技能认证说明
            CriminalCheck: res.Data.rows[0].CriminalCheck,//无犯罪证明
            ConsultantAttachment: [],//续聘附件材料
            // ConsultantAttachment: res.Data.rows[0].ConsultantAttachment,//续聘附件材料
            AppointmentStart: res.Data.rows[0].AppointmentStart, //聘用开始日期
            AppointmentEnd: res.Data.rows[0].AppointmentEnd, //聘用借宿日期
            AppointmentInstruction: res.Data.rows[0].AppointmentInstruction, //聘用说明
            ConsultantCertificate: [],
            Bak2:''
          }
          // ConsultantCertificate: res.Data.rows[0].ConsultantCertificate,//专业技能证书
          this.guolist2 = [];
          if (res.Data.rows[0].ConsultantAttachment) {
            for (let item of res.Data.rows[0].ConsultantAttachment.split(',')) {
              let itemindexOf = item.lastIndexOf("\\");
              let data = {
                name: item.slice(itemindexOf + 1),
                img: item
              }
              this.guolist2.push(data)
            }
          }

          this.guolist1 = []
          if(res.Data.rows[0].ConsultantCertificate){
            for (let item of res.Data.rows[0].ConsultantCertificate.split(',')) {
              this.guolist1.push(item)
            }
          }

          for (let i = 0; i < this.campus_list.length; i++) {
            if (this.campus_list[i].cDicValue == res.Data.rows[0].Bak2) {
              this.zusruleForm.Bak2 = (this.campus_list[i].dicKey).toString()
            }
          }

        }
      })
    } else {
      this.$Http_Post('User/PersonalData').then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.indexruleForm2.UserID = res.Data.UserID;
          this.indexruleForm2.RealName = res.Data.RealName;
          this.indexruleForm2.Sex = res.Data.Sex;
          this.indexruleForm2.Birthday = res.Data.Birthday;
          this.indexruleForm2.Phone = res.Data.Phone;
          this.indexruleForm2.IDCard = res.Data.IDCard;
          this.indexruleForm2.AccountType = res.Data.AccountType;
          this.indexruleForm2.DeptID = res.Data.DeptNameJ;
          this.indexruleForm2.Nation = res.Data.Nation;
          this.indexruleForm2.NativePlace = res.Data.NativePlace;
          this.indexruleForm2.TheEntranceDate = res.Data.TheEntranceDate;
          this.indexruleForm2.Email = res.Data.Email;
          this.indexruleForm2.MarriageState = res.Data.MarriageState;
          this.indexruleForm2.VideoAccount = res.Data.VideoAccount;
          this.indexruleForm2.EmergencyName = res.Data.EmergencyName;
          this.indexruleForm2.UrgentRelationships = res.Data.UrgentRelationships;
          this.indexruleForm2.EmergencyPhone = res.Data.EmergencyPhone;
        }
      })
    }

    

    this.$Http_Post('User/GetDictionaryList ', { DicTypCode: 16 }).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.campus_list = res.Data;
        this.Campus = res.Data[0].dicKey;
      } else {
      }
    })
  },
}
</script>
<style scoped>
.about .el-form-item{margin: 0;}
.system_name {
  float: left;
}

.header-menu {
  float: right;
  line-height: 54px;
  font-size: 20px;
}

.menu-list {
  float: 12px verdana, arial, sans-serif;
}

.menu-list,.menu-list li {
  list-style: none;
  padding: 0;
  margin: 0;
}

.menu-list li {
  float: left;
  margin-left: 20px;
  position: relative;
}

.username {
  font-size: 12px;
  float: left;
  margin-left: 5px;
  color: #686b6e;
}

.grid-content {
  background-color: #fff;
  height: 42px;

  /* 修改顶部导肮高度 */
}

.grid-content .el-tabs__header {
  margin: 0px !important;
  padding-left: 15px !important;
}

.grid-content .el-tabs__item {
  height: 35px;
  line-height: 35px;
}

.is-top {
  position: relative !important;
  z-index: 99999999999999 !important;
  background-color: #fff !important;
  padding-left: 15px;
}

.maincontent {
  width: 100%;
}

.userinformation-box {
  float: left;
  margin-top: 15px;
  border: 1px solid #d0d1d2;
  height: 25px;
  width: 25px;
}

.userinformation {
  width: 120px;
  height: 120px;
  background-color: rgb(255, 255, 255);
  position: absolute;
  top: 20px;
  right: -50px;
  z-index: 99999;
  display: none;
}

.userinformation-box:hover .userinformation {
  display: block;
}

.userinformation p {
  margin-top: 16px;
  margin-left: 20px;
  font-size: 14px;
}

.more-menu:hover {
  color: #4399ef !important;
}

.headermenu__item {
  position: relative;
  display: block;
  line-height: 20px;
  text-align: center;
  padding: 5px;
  color: #60666c;
  z-index: 99999999999;
}

.headermenu__item:hover {
  background-color: #deedfd;
  cursor: pointer;
  color: #2d6cd7;
}

.msg-tip {
  position: absolute;
  top: 10px;
  width: 18px;
  height: 18px;
  background-color: #ef5143;
  color: #fff;
  right: -8px;
  border-radius: 9px;
  line-height: 18px;
  text-align: center;
  font-size: 10px;
  transform: scale(0.7);
  box-shadow: 0px 3px #eaebec;
}

.el-avatar>img {
  width: 100%;
}

.messagess {
  width: 220px;
  max-height: 402px;
  background-color: #fff;
  position: absolute;
  z-index: 9999;
  top: 50px;
  right: 0px;
  padding: 8px 10px;
  border: 1px solid rgb(207, 204, 204);
  box-shadow: 0px 0px 5px rgb(243, 243, 243);
  border-radius: 8px;
  overflow: auto;
  display: none;
}

.messagess li {
  width: calc(100% - 20px);
  padding: 0px 10px;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  margin-left: 0px;
  text-align: left;
  position: relative;
}

.messagess li .cnt {
  width: 190px;
  word-break: keep-all;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.No-Read {
  color: black;
}

.No-Read .tip {
  width: 6px;
  height: 6px;
  border-radius: 3px;
  background-color: #ef5143;
  box-shadow: 0px 0px 3px #b86e67;
  position: absolute;
  top: 17.5px;
  left: 0px;
}

.Do-Read {
  color: #9b9ea5;
}

.menu-list-li {
  position: relative;
}

.menu-list-li:hover .messagess {
  display: block;
}

.ExamineStatistical .block {
  float: right;
  margin-top: 20px;
}

.xsnkmlx .el-dialog__header {
  height: 0px !important;
  padding: 0px !important;
}
.vssfdvd .avatar-uploader .el-upload {border: 1px dashed #d9d9d9;border-radius: 6px;cursor: pointer;position: relative;overflow: hidden;}
.vssfdvd .avatar-uploader .el-upload:hover {border-color: #409eff;}
 .vssfdvd .avatar-uploader-icon {font-size: 28px;color: #8c939d;width: 215px;height: 148px;line-height: 148px;text-align: center;border: 1px solid #d1d1d1;}
.avatar {width: 215px;height: 148px;display: block;}
.cover {margin-left: 10px;font-size: 14px;vertical-align: middle;box-sizing: border-box;position: relative;color: #606266;height: 175px;}
.vssfdvd .avatar-uploader {position: absolute;top: 0px;left: 0px;}
.headerinstitutional{font-size: 16px;background: #C9E3FF;border-radius: 200px;line-height: 1;padding: 4px 20px; display: inline-block;cursor: pointer;}
.headerinstitutional span{font-size: 12px;background: #3D98FF;padding:1px 4px;color: #fff;border-radius: 3px;margin-right: 4px;}
</style>
